export const BASE_URL = {
  AUTH: process.env.REACT_APP_AUTH_CONTEXT,
  PRODUCT: process.env.REACT_APP_AE_PRODUCT_CONTEXT,
  WALLET: process.env.REACT_APP_AE_WALLET_CONTEXT,
  CUSTOMER: process.env.REACT_APP_AE_CUSOMTER_CONTEXT,
  CARD: process.env.REACT_APP_AE_CARD_CONTEXT,
  MERCHANT: process.env.REACT_APP_AE_MERCHANT_CONTEXT,
  AE: {
    PRODUCT: process.env.REACT_APP_AE_PRODUCT_CONTEXT,
    WALLET: process.env.REACT_APP_AE_WALLET_CONTEXT,
    CUSTOMER: process.env.REACT_APP_AE_CUSOMTER_CONTEXT,
    CARD: process.env.REACT_APP_AE_CARD_CONTEXT,
    MERCHANT: process.env.REACT_APP_AE_MERCHANT_CONTEXT,
    OMNIFY: process.env.REACT_APP_AE_OMNIFY_CONTEXT,
  },
  EG: {
    PRODUCT: process.env.REACT_APP_EG_PRODUCT_CONTEXT,
    WALLET: process.env.REACT_APP_EG_WALLET_CONTEXT,
    CUSTOMER: process.env.REACT_APP_EG_CUSOMTER_CONTEXT,
    CARD: process.env.REACT_APP_EG_CARD_CONTEXT,
    MERCHANT: process.env.REACT_APP_EG_MERCHANT_CONTEXT,
  },
};
